// import store from "../store";
import Request from "./Request";

class Api {
  url: string = "";
  lastRequest: string = "";
  lastRequestData: object | undefined = {};

  constructor() {
    this.url = `${process.env.VUE_APP_XHR_ROOT}`;
  }

  requestGetList = (url: string, data?: object, returnVal?: string): any =>
    this.request(url, data, "getList", returnVal);

  requestGet = (url: string, data?: object, returnVal?: string): any =>
    this.request(url, data, "get", returnVal);

  requestPost = (url: string, data: object, returnVal?: string): any =>
    this.request(url, data, "post", returnVal);

  requestPut = (url: string, data: object, returnVal?: string): any =>
    this.request(url, data, "put", returnVal);

  requestDelete = (url: string, data?: object, returnVal?: string): any =>
    this.request(url, data, "delete", returnVal);

  request(
    url: string,
    data: object | undefined,
    method: string = "get",
    returnVal: string = ""
  ): any {
    this.lastRequest = url;
    this.lastRequestData = data;

    return (Request as any)
      [method](url, data)
      .then((res: object) => this.defaultResolver(res, returnVal))
      .catch((e: any) => this.log(e));
  }

  prepareUrl(endpoint: string, param?: any): string {
    // endpoint = endpoint.replace("%mode", store.getters["App/mode"]);
    param = param || "";
    const url = `${this.url}${endpoint}${param}`;
    return url;
  }

  defaultResolver(
    response: object,
    field: string,
    defaultValue: any = []
  ): any {
    return new Promise((resolve, reject) => {
      if (
        field &&
        response &&
        typeof (response as any)[field] !== "undefined"
      ) {
        resolve((response as any)[field]);
      } else if (response && (response as any).success && field) {
        resolve(defaultValue);
      } else if (response && (response as any).success) {
        resolve(response);
      } else {
        reject(response);
      }
    });
  }

  log(e: any): any {
    console.group("REQUEST ERROR");
    console.log("URL:", this.lastRequest);
    console.log("Request data:");
    console.table(this.lastRequestData);
    console.log("Response data:");
    console.table(e);
    console.groupEnd();
    return e;
  }
}

export default Api;
